<script>
export default {
    name: "HomeServiceGift",
    props: {
        gifts: {
            type: Array,
            required: false
        }
    },
    data() {
        return {
            tableau: [
                `MACHINE À CAFÉ <span> compatible capsules</span> `, "JVC airpods", "Aspirateur Robot", "SmartWatch GTS4" , "Airfryer",
            ],
        }
    }
}
</script>

<template>
    <div class="">
        <div class="table-wrapper">
            <div class="table-title-wrapper">
                <p class="table-title">Quelques  exemples  de cadeaux </p>
                <p class="table-price">Prix</p>
            </div>
            <div class="table-item" v-for="elem in gifts ? gifts : tableau">
                <p class="table-item__gift" v-html="elem"></p>
                <p class="table-item__price">GRATUIT</p>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
